import React from 'react'
import FlexboxChallenge from './FlexboxChallenge'

export default class extends React.Component {
  render() {
    const literalStyles = `
      .no-cheating, .flexbox-challenge {
        height: 500px;
      }

      .no-cheating > *, .flexbox-challenge > *{
        margin: 10px;
        height: 60px;
        width: calc(100% - 20px);
      }

      .no-cheating {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }

      .flexbox-challenge {
        display: flex;
        flex-direction: BBBRWWWERRKKK;
        justify-content: RRRAAAAGHHH;
      }
    `

    return (
      <FlexboxChallenge
        title="Flexbox Devtools Challenge"
        description="Fix the Flexbox layout using just the devtools!"
        literalStyles={literalStyles}
        nextChallenge={3}
      >
        <div />
        <div />
        <div />
        <div />
      </FlexboxChallenge>
    )
  }
}
